import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { obtenerListadoPedidos, bloquearCliente, anularPedidoApi, cambiarEstadoPedidoApi } from '../../services/pedidosServicio';
import { hoyChile } from '../../services/utils';

const AdministradorPedidos = () => {
    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
    const hoy = hoyChile();
    const [filtros, setFiltros] = useState({ inicio: hoy, fin: hoy, origen: 'TODOS' });

    const ORIGEN_LABELS = { MOSTRADOR: 'TPV', MESA: 'Mesa', WEB: 'Web' };

    const pedidosFiltrados = filtros.origen === 'TODOS'
        ? pedidos
        : pedidos.filter(p => (p.plataforma_origen || 'MOSTRADOR').toUpperCase() === filtros.origen);

    const consultarHistorial = async () => {
        setLoading(true);
        try {
            const data = await obtenerListadoPedidos(filtros.inicio, filtros.fin);
            setPedidos(data || []);
        } catch (error) { toast.error("Error: " + error.message); }
        finally { setLoading(false); }
    };

    useEffect(() => { consultarHistorial(); }, []);

    const handleAnularPedido = async (id, displayId) => {
        if (!window.confirm(`⚠️ ¿ANULAR PEDIDO #${displayId || id}?`)) return;
        try {
            await anularPedidoApi(id);
            toast.success(`🚫 Pedido #${displayId || id} anulado.`);
            setPedidoSeleccionado(null);
            consultarHistorial();
        } catch (error) { toast.error("Error: " + error.message); }
    };

    const handleCambiarEstado = async (pedidoId, nuevoEstado) => {
        try {
            await cambiarEstadoPedidoApi(pedidoId, nuevoEstado);
            toast.success(`✅ Estado cambiado a ${['', 'Recibida', 'Preparando', 'Lista', 'EnReparto', 'Entregada', 'Cancelada', 'Por Cobrar'][nuevoEstado] || 'Desconocido'}`);
            setPedidoSeleccionado(null);
            consultarHistorial();
        } catch (error) {
            toast.error("Error al cambiar estado: " + error.message);
        }
    };

    const handleBloquearCliente = async (telefono, nombre) => {
        if (!window.confirm(`⚠️ ¿BLOQUEAR NÚMERO ${telefono} (Cliente: ${nombre})?`)) return;
        try {
            await bloquearCliente(telefono, "Bloqueo manual por fraude");
            toast.success("🚫 Cliente bloqueado.");
            consultarHistorial();
        } catch (error) {
            toast.error("Error al bloquear: " + error.message);
        }
    };

    // --- FUNCIÓN DINÁMICA DE COLOR DE ESTADO ---
    const renderEstadoBadge = (estado) => {
        const est = (estado || "").toUpperCase();

        // Si el estado es cualquiera de estos, le mandamos el ROJO EXTREMO
        if (est === "ANULADO" || est === "CANCELADO" || est === "CANCELADA" || est === "NULO") {
            return (
                <span className="badge-extremo-rojo shadow-sm">
                    <i className="fas fa-times-circle mr-1"></i> {est}
                </span>
            );
        }

        if (est === "ENTREGADO" || est === "ENTREGADA") {
            return (
                <span className="badge-extremo-verde shadow-sm">
                    <i className="fas fa-check-double mr-1"></i> {est}
                </span>
            );
        }

        // Cualquier otro estado (Pendiente, Preparando, etc.)
        return (
            <span className="badge-extremo-amarillo shadow-sm">
                <i className="fas fa-clock mr-1"></i> {est}
            </span>
        );
    };

    // --- 3. MODAL DE DETALLE DEL PEDIDO (Vuelto a la vida) ---

    const ModalDetalle = () => {
        if (!pedidoSeleccionado) return null;
        const p = pedidoSeleccionado;

        const estStr = (p.estado_nombre || "").toUpperCase();
        const esMalo = ["ANULADO", "CANCELADO", "CANCELADA"].includes(estStr);

        const metodoPagoClass = p.pagado === 1 ? 'bg-success text-white' : 'bg-warning text-dark';
        
        // El backend devuelve 'items' como array ya parseado desde items_json
        let items = [];
        if (Array.isArray(p.items)) {
            items = p.items;
        } else if (p.items_json) {
            items = typeof p.items_json === 'string' ? JSON.parse(p.items_json) : p.items_json;
        }

        return (
            <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(3px)', zIndex: 1050 }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content rounded-lg border-0 shadow-lg">

                        <div className={`modal-header ${esMalo ? 'bg-danger' : 'bg-dark'} text-white border-0`}>
                            <h5 className="modal-title font-weight-bold">
                                {esMalo && <i className="fas fa-ban mr-2"></i>}
                                Detalle Orden #{p.display_id || p.id}
                            </h5>
                            <button type="button" className="close text-white" onClick={() => setPedidoSeleccionado(null)}>&times;</button>
                        </div>

                        <div className="modal-body p-4 text-dark">
                            <div className="row">
                                {/* Columna Izquierda: Auditoría */}
                                <div className="col-md-5 border-right">
                                    <h6 className="text-uppercase small font-weight-bold text-muted border-bottom pb-2 mb-3">Auditoría</h6>
                                    <p className="mb-1"><strong>Cliente:</strong> {p.cliente_nombre}</p>
                                    <p className="mb-1"><strong>Teléfono:</strong> {p.cliente_telefono || 'N/A'}</p>
                                    <p className="mb-1"><strong>Método Pago:</strong> <span className={`badge ${metodoPagoClass}`}>{p.metodo_pago}</span></p>
                                    <p className="mb-1"><strong>Fecha:</strong> {new Date(p.fecha_creacion).toLocaleString()}</p>

                                    <div className="mt-4 text-center">
                                        <div className="mb-3">
                                            {renderEstadoBadge(p.estado_nombre)}
                                        </div>

                                        {!esMalo && (
                                            <button className="btn btn-danger btn-block rounded font-weight-bold py-2 mb-2" onClick={() => handleAnularPedido(p.id, p.display_id)}>
                                                ANULAR VENTA
                                            </button>
                                        )}

                                        {/* 🚩 SELECTOR DE ESTADO */}
                                        {!esMalo && (
                                            <div className="mt-3">
                                                <label className="small font-weight-bold text-muted d-block mb-1">Cambiar Estado:</label>
                                                <select
                                                    className="form-control form-control-sm mb-2"
                                                    defaultValue=""
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (val) handleCambiarEstado(p.id, Number(val));
                                                        e.target.value = ""; // Reset para que se pueda volver a usar
                                                    }}
                                                >
                                                    <option value="" disabled>Seleccionar...</option>
                                                    <option value="2">Preparando</option>
                                                    <option value="3">Lista</option>
                                                    <option value="4">En Reparto</option>
                                                    <option value="5">Entregada</option>
                                                    <option value="7">Por Cobrar</option>
                                                </select>
                                            </div>
                                        )}
                                        <button className="btn btn-outline-danger btn-block btn-sm" onClick={() => handleBloquearCliente(p.cliente_telefono, p.cliente_nombre)} disabled={!p.cliente_telefono}>
                                            Bloquear Número
                                        </button>
                                    </div>
                                </div>

                                {/* Columna Derecha: Productos (Aquí está el cambio) */}
                                <div className="col-md-7">
                                    <h6 className="text-uppercase small font-weight-bold text-muted border-bottom pb-2 mb-3">Productos</h6>
                                    <div className="overflow-auto" style={{ maxHeight: '400px' }}>
                                        <ul className="list-unstyled">
                                            {items.map((item, index) => (
                                                <li key={index} className="mb-3 pb-2 border-bottom">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div>
                                                            <strong className="d-block">{item.cantidad}x {item.nombre}</strong>
                                                            
                                                            {/* 🚩 MOSTRAR OPCIONES ESCOGIDAS (Basado en tu DB) */}
                                                            {item.opciones_escogidas && item.opciones_escogidas.length > 0 ? (
                                                                <div className="pl-3 mt-1 small text-info border-left ml-1" style={{ borderLeftColor: '#17a2b8', borderLeftWidth: '3px' }}>
                                                                    {item.opciones_escogidas.map((opt, oIdx) => (
                                                                        <div key={oIdx}>
                                                                            + {opt.nombre} {opt.precio > 0 ? `(+$${opt.precio.toLocaleString('es-CL')})` : ''}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                /* Backup: Mostrar el string formateado si no hay array */
                                                                item.variantes_detalles && (
                                                                    <small className="text-muted d-block pl-2 italic">{item.variantes_detalles}</small>
                                                                )
                                                            )}
                                                        </div>
                                                        <span className="font-weight-bold">${Number(item.precio || item.valor).toLocaleString('es-CL')}</span>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="d-flex justify-content-between h4 font-weight-bold mt-4 pt-3 border-top border-dark">
                                        <span>TOTAL:</span>
                                        <span>${Number(p.total).toLocaleString('es-CL')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="bg-light min-vh-100" style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
            <ToastContainer position="top-right" autoClose={3000} />
            
            {/* 🚩 HEADER SHOPIFY */}
            <div className="bg-white border-bottom shadow-sm px-4 py-3 sticky-top" style={{ zIndex: 100 }}>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div>
                        <h2 className="h5 fw-bold mb-0 text-dark">
                            <i className="fas fa-shopping-bag text-dark mr-2"></i> Pedidos
                        </h2>
                        <small className="text-muted">{pedidosFiltrados.length} pedido{pedidosFiltrados.length !== 1 ? 's' : ''}</small>
                    </div>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        <select
                            className="form-control form-control-sm rounded-pill px-3"
                            style={{ fontSize: '0.85rem', width: 'auto' }}
                            value={filtros.origen}
                            onChange={e => setFiltros({ ...filtros, origen: e.target.value })}
                        >
                            <option value="TODOS">Todos los orígenes</option>
                            <option value="MOSTRADOR">TPV</option>
                            <option value="MESA">Mesa</option>
                            <option value="WEB">Web</option>
                        </select>
                        <div className="d-flex align-items-center bg-light rounded-pill px-3 py-1">
                            <i className="fas fa-calendar-alt text-muted mr-2" style={{ fontSize: '0.8rem' }}></i>
                            <input type="date" className="border-0 bg-transparent form-control-sm py-1" style={{ fontSize: '0.85rem', outline: 'none', width: '130px' }} value={filtros.inicio} onChange={e => setFiltros({ ...filtros, inicio: e.target.value })} />
                            <span className="text-muted mx-1">—</span>
                            <input type="date" className="border-0 bg-transparent form-control-sm py-1" style={{ fontSize: '0.85rem', outline: 'none', width: '130px' }} value={filtros.fin} onChange={e => setFiltros({ ...filtros, fin: e.target.value })} />
                        </div>
                        <button className="btn btn-dark btn-sm rounded-pill px-4 fw-bold shadow-sm" onClick={consultarHistorial} disabled={loading} style={{ fontSize: '0.85rem' }}>
                            {loading ? <><i className="fas fa-spinner fa-spin mr-1"></i> Buscando...</> : '🔍 Buscar'}
                        </button>
                    </div>
                </div>
            </div>

            <div className="p-4">
                {/* 🚩 GRID DE TARJETAS SHOPIFY */}
                {loading && pedidosFiltrados.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-dark mb-3" role="status"></div>
                        <p className="text-muted">Cargando pedidos...</p>
                    </div>
                ) : pedidosFiltrados.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="mb-3" style={{ fontSize: '3rem', opacity: 0.3 }}>📦</div>
                        <h5 className="text-muted fw-bold">No hay pedidos</h5>
                        <p className="text-muted small">Prueba con otro rango de fechas u origen.</p>
                    </div>
                ) : (
                    <div className="table-responsive bg-white rounded shadow-sm" style={{ maxHeight: 'calc(100vh - 160px)', overflowY: 'auto' }}>
                        <table className="table table-hover align-middle mb-0">
                            <thead className="sticky-top bg-white" style={{ top: 0, zIndex: 1 }}>
                                <tr>
                                    <th className="text-muted small text-uppercase" style={{ fontSize: '0.75rem' }}>Pedido</th>
                                    <th className="text-muted small text-uppercase" style={{ fontSize: '0.75rem' }}>Fecha</th>
                                    <th className="text-muted small text-uppercase" style={{ fontSize: '0.75rem' }}>Origen</th>
                                    <th className="text-muted small text-uppercase" style={{ fontSize: '0.75rem' }}>Cliente</th>
                                    <th className="text-muted small text-uppercase" style={{ fontSize: '0.75rem' }}>Estado</th>
                                    <th className="text-muted small text-uppercase" style={{ fontSize: '0.75rem' }}>Pago</th>
                                    <th className="text-muted small text-uppercase text-right" style={{ fontSize: '0.75rem' }}>Total</th>
                                    <th className="text-muted small text-uppercase text-right" style={{ fontSize: '0.75rem' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pedidosFiltrados.map((p) => {
                                    const estStr = (p.estado_nombre || "").toUpperCase();
                                    const esMalo = ["ANULADO", "CANCELADO", "CANCELADA"].includes(estStr);
                                    const origenKey = (p.plataforma_origen || 'MOSTRADOR').toUpperCase();

                                    return (
                                        <tr key={p.id} style={{ cursor: 'pointer' }} onClick={() => setPedidoSeleccionado(p)}>
                                            <td className="fw-bold text-dark">#{p.display_id || p.id}</td>
                                            <td className="text-muted small">
                                                {p.fecha_creacion ? new Date(p.fecha_creacion).toLocaleDateString('es-CL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''}
                                            </td>
                                            <td className="text-muted small">{ORIGEN_LABELS[origenKey] || origenKey}</td>
                                            <td>
                                                <div className="text-dark" style={{ fontSize: '0.9rem' }}>{p.cliente_nombre}</div>
                                                <div className="text-muted small">{p.cliente_telefono || 'Sin teléfono'}</div>
                                            </td>
                                            <td>{renderEstadoBadge(p.estado_nombre)}</td>
                                            <td>
                                                <span className={`badge-extremo-${p.pagado === 1 ? 'verde' : 'amarillo'}`}>
                                                    {p.metodo_pago || 'Pendiente'}
                                                </span>
                                            </td>
                                            <td className={`text-right fw-bold ${esMalo ? 'text-muted' : 'text-dark'}`}>
                                                {esMalo && <span style={{ textDecoration: 'line-through', opacity: 0.5 }}>$</span>}
                                                ${Number(p.total).toLocaleString('es-CL')}
                                            </td>
                                            <td className="text-right" onClick={(e) => e.stopPropagation()}>
                                                <button
                                                    className="btn btn-sm rounded-pill shadow-sm mr-1"
                                                    style={{ backgroundColor: '#f3f4f6', color: '#1f2937', border: 'none', fontSize: '0.8rem' }}
                                                    onClick={() => setPedidoSeleccionado(p)}
                                                    title="Ver detalle"
                                                >
                                                    <i className="fas fa-eye"></i>
                                                </button>
                                                {!esMalo && (
                                                    <button
                                                        className="btn btn-sm rounded-pill shadow-sm"
                                                        style={{ backgroundColor: '#fef2f2', color: '#dc2626', border: 'none', fontSize: '0.8rem' }}
                                                        title="Anular Pedido"
                                                        onClick={() => handleAnularPedido(p.id, p.display_id)}
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* RENDERIZAR MODAL AHORA SÍ */}
            <ModalDetalle />

            <style>{`

                /* BADGES SHOPIFY */
                .badge-extremo-rojo {
                    background-color: #fef2f2 !important;
                    color: #dc2626 !important;
                    padding: 4px 12px;
                    border-radius: 100px;
                    font-weight: 600;
                    font-size: 0.75rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    border: 1px solid #fecaca;
                }

                .badge-extremo-verde {
                    background-color: #ecfdf5 !important;
                    color: #059669 !important;
                    padding: 4px 12px;
                    border-radius: 100px;
                    font-weight: 600;
                    font-size: 0.75rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    border: 1px solid #a7f3d0;
                }

                .badge-extremo-amarillo {
                    background-color: #fffbeb !important;
                    color: #d97706 !important;
                    padding: 4px 12px;
                    border-radius: 100px;
                    font-weight: 600;
                    font-size: 0.75rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    border: 1px solid #fde68a;
                }

                .text-strike { text-decoration: line-through; }

                .gap-2 { gap: 0.5rem; }
                .bg-opacity-10 { --bg-opacity: 0.1; }
            `}</style>
        </div>
    );
};

export default AdministradorPedidos;